import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import {
  parseTime,
  RoleExperienceValue,
  TimePeriod,
} from '@/components/Forms/QuestionType/CrewType';
import CrewExtraExperience from '@/components/Forms/QuestionType/CrewExtraExperience.vue';
import CrewTimeInput from '@/components/Forms/QuestionType/CrewTimeInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrewExperienceType',
  props: {
  value: {
    type: Object as PropType<RoleExperienceValue>,
    required: true,
  },
  info: {
    type: Object as PropType<{ label: string; ranks: string[]; min: number }>,
  },
},
  emits: {
  input: (value: RoleExperienceValue) => value && true,
},
  setup(__props, { emit }) {

const props = __props;





const time = computed({
  get() {
    return props.value.time;
  },
  set(time: TimePeriod) {
    emit('input', { ...props.value, time });
  },
});

const previous = computed({
  get() {
    return props.value.previous || [];
  },
  set(v) {
    emit('input', { ...props.value, previous: v });
  },
});
const more = computed(() => {
  const t = parseTime(time.value);
  return t.Y * 12 + t.M <= props.info.min;
});

return { __sfc: true,props, emit, time, previous, more, CrewExtraExperience, CrewTimeInput }
}

})